import * as Sentry from "@sentry/react";

/**
 * Initialise Sentry only if a DSN is configured at build time. This is
 * deliberately a no-op for local dev (`yarn start`) and Vercel preview
 * deploys without `REACT_APP_SENTRY_DSN` set.
 *
 * To enable in production:
 *   REACT_APP_SENTRY_DSN=https://<key>@<org>.ingest.sentry.io/<project>
 *   REACT_APP_SENTRY_ENV=production         # optional, defaults to NODE_ENV
 *   REACT_APP_SENTRY_RELEASE=<git-sha>      # optional, set in CI
 */
export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
  });
}

export { Sentry };
